export const URL_PARAM_STATE = 'stateOrProvince'
export const URL_PARAM_CITY = 'city'
export const URL_PARAM_COUNTRY = 'country'
export const URL_PARAM_CUSTOMER_NAME = 'customerName'
export const URL_PARAM_BUSINESS_UNIT_ID = 'businessUnitId'
export const URL_PARAM_ADDRESS_SEARCH_PARAMS = 'addressSearchParams'
export const URL_PARAM_ID = 'id'
export const URL_PARAM_POSTAL_CODE = 'postalCode'
